
import ogPagesMixins from '@/mixins/ogPagesMixins'
import isClient from '@/mixins/isClient'
export default {
  mixins: [ogPagesMixins, isClient],
  scrollToTop: true,
  props: {
    author: {
      type: Object,
      default: null,
    },
    seoAuthorName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      recommendations: null,
      recommendationsLimit: 10,
      recommendationsOffset: 0,
      recommendationsCount: 0,
    }
  },
  async fetch() {
    if (this.author) await this.fetchRecommendations()
  },
  computed: {
    seoImage() {
      return {
        url: `https://api.megasreda.ru/image/ogimage/author/${this.author?.id}.jpg`,
        urlVk: `https://api.megasreda.ru/image/ogimage/author/vk/${this.author?.id}.jpg`,
        urlTw: `https://api.megasreda.ru/image/ogimage/author/${this.author?.id}.jpg`,
        type: 'image/jpeg',
        width: 1200,
        height: 630,
      }
    },
    authorName() {
      if (this.author?.type === 'COMPANY') {
        return this.author.profile.title
          ? this.author.profile.title
          : this.author?.username
      } else {
        return this.author?.profile?.firstName && this.author?.profile?.lastName
          ? `${this.author?.profile?.firstName} ${this.author?.profile?.lastName}`
          : this.author?.username
      }
    },
    seoTitle() {
      return `${this.seoAuthorName}: рекомендации | Мегасреда`
    },
    seoDescription() {
      return `Все рекомендации ${
        this.author.type === 'COMPANY' ? 'компании' : 'пользователя'
      } ${this.seoAuthorName} на Мегасреде`
    },
    seoH1() {
      return `Рекомендации ${
        this.author.type === 'COMPANY' ? 'компании' : 'пользователя'
      } ${this.seoAuthorName} опубликованные для аудитории Мегасреды`
    },
  },
  created() {
    if (process?.client) {
      this.$eventBus.$on('publish-recommendation', () =>
        this.updateRecommendation()
      )
    }
  },
  beforeDestroy() {
    this.$eventBus.$off('publish-recommendation')
  },
  methods: {
    loadMore() {
      this.recommendationsOffset =
        this.recommendationsOffset + this.recommendationsLimit
      this.fetchRecommendations()
    },

    updateRecommendation() {
      this.recommendations = null
      this.$fetch()
      this.$emit('update-post')
    },
    removeRecommendation() {
      this.recommendations = null
      this.$fetch()
      this.$emit('remove-post')
    },

    async fetchRecommendations() {
      const { recommendations, countAllPublishedRecommendations } =
        await this.$axios.$get(
          `/recommendations/provided/all/${this.author.id}`,
          {
            params: {
              limit: this.recommendationsLimit,
              offset: this.recommendationsOffset,
            },
          }
        )

      this.recommendationsCount = countAllPublishedRecommendations
      this.recommendations = this.recommendations?.length
        ? this.recommendations.concat(recommendations)
        : recommendations
    },
  },
}
